import React, { useState } from "react";
import FeatherIcon from "feather-icons-react";
import ListFilterModal from "./ListFilterModal";


const showCountDefault = 5;

const FilterPanel = ({
  filters,
  selectedFilters,
  onCheckboxChange,
  onYearChange,
  onClearFilters,
  onResultCountChange,
  resultCountOptions,
  resultCount,
  onYearApply,
  yearInputs,
  expandedCategory,
  onExpandCategory,
  extraFilters, // yeni prop
  loadingFilters, // <-- yeni prop
  fetchAggrItems, // yeni prop
  onApplyModalSelections,
  userDatabase, // yeni prop
}) => {
  const [showMore, setShowMore] = useState({
    documentTypes: false,
    journals: false,
    topics: false,
    languages: false,
    publishers: false,
  });

  // komponentin içinde (useState satırlarının yanına)
  const [modalOpen, setModalOpen] = useState(false);
  const [modalMeta, setModalMeta] = useState({
    title: "", category: "", isKeywordCategory: false, initialSelected: []
  });

  const openModalForCategory = (category, title) => {
    const isKeywordCategory = ["keywords", "journals", "languages"].includes(category);
    const selected = selectedFilters[category] || [];
    setModalMeta({
      title, category, isKeywordCategory,
      initialSelected: selected
    });
    setModalOpen(true);
  };


  const languageMap = {
    "tur": "Türkçe",
    "eng": "İngilizce",
    "tur,eng": "Türkçe ve İngilizce",
    "ara": "Arapça",
    "ger": "Almanca",
    "fre": "Fransızca",
    "rus": "Rusça",
    "other": "Diğer",
    "Türkçe": "Türkçe"
    // ihtiyaca göre ekle
  };

  const convertLanguages = (items) => {
    if (!Array.isArray(items)) return [];
    return items.map(item => ({
      ...item,
      label: languageMap[item.key] || languageMap[item.label] || item.label || item.key
    }));
  };


  const renderRadioList = (items, category) => {
    if (!Array.isArray(items)) return null;
    return (
      <>
        {items.map((item, i) => (
          <div className="form-check d-flex align-items-start" key={i}>
            <input
              className="form-check-input mt-0 me-1"   // ⬅️ üst marjı sıfırla
              type="checkbox"
              name={category}
              id={`${category}-${i}`}
              checked={selectedFilters[category] === item.value}
              onChange={() => {
                if (selectedFilters[category] === item.value) {
                  onCheckboxChange(category, -1);
                } else {
                  onCheckboxChange(category, item);
                }
              }}
              style={{ width: 16, height: 16 }}
            />
            <label
              className="form-check-label mb-0 d-flex justify-content-between align-items-start"
              htmlFor={`${category}-${i}`}
              style={{ width: "95%" }}
            >
              <span className="text-break text-darkfume text-xs" style={{ flex: 1 }}>
                {item.label}
              </span>
              {typeof item.count !== "undefined" && (
                <span className="text-muted ms-2 text-xs">
                  {item.count.toLocaleString("tr-TR")}
                </span>
              )}
            </label>
          </div>
        ))}

      </>
    );
  };

  const mergeJournalDbs = (items) => {
    if (!Array.isArray(items)) return [];
    const merged = [];
    const journalVariants = ["akademik dergiler", "popüler dergiler", "populer dergiler"];
    let hasMergedJournal = false;

    const getCount = (it) => {
      const v = it?.value ?? it?.count ?? 0;
      return isNaN(Number(v)) ? 0 : Number(v);
    };

    items.forEach(item => {
      const lbl = String(item.label || '').toLowerCase();
      if (journalVariants.includes(lbl)) {
        if (!hasMergedJournal) {
          const totalCount = items.reduce((sum, it) => {
            if (journalVariants.includes(String(it.label || '').toLowerCase())) {
              return sum + getCount(it);
            }
            return sum;
          }, 0);
          merged.push({
            ...item,
            label: "İdealonline Süreli Yayınlar",
            mergedLabels: ["Akademik Dergiler", "Popüler Dergiler"],
            value: totalCount,
            count: totalCount
          });
          hasMergedJournal = true;
        }
      } else {
        merged.push(item);
      }
    });
    return merged;
  };


  // Kitap ve kitap bölümü için akademik/popüler ayrımını kaldırıp, tek seçenek olarak göster
  const mergeBookTypes = (items) => {
    if (!Array.isArray(items)) return [];
    const merged = [];
    let hasBook = false, hasBookSection = false;
    items.forEach(item => {
      const lbl = String(item.label || '').toLowerCase();
      const getCount = (it) => {
        const v = it?.value ?? it?.count ?? 0;
        const num = Number(v);
        return isNaN(num) ? 0 : num;
      };

      if (["akademik kitap", "popüler kitap", "populer kitap"].includes(lbl)) {
        if (!hasBook) {
          // find other variant counts too
          const siblingCount = items.reduce((sum, it) => {
            const l = String(it.label || '').toLowerCase();
            if (["akademik kitap", "popüler kitap", "populer kitap"].includes(l)) {
              return sum + getCount(it);
            }
            return sum;
          }, 0);
          merged.push({ ...item, label: "Kitap", mergedLabels: ["Akademik Kitap", "Popüler Kitap"], value: siblingCount, count: siblingCount });
          hasBook = true;
        }
      } else if (["akademik kitap bölümü", "popüler kitap bölümü", "populer kitap bölumu", "populer kitap bölümü", "akademik kitap bolumu"].includes(lbl)) {
        if (!hasBookSection) {
          const siblingCount = items.reduce((sum, it) => {
            const l = String(it.label || '').toLowerCase();
            if (["akademik kitap bölümü", "popüler kitap bölümü", "populer kitap bolumu", "populer kitap bölümü", "akademik kitap bolumu"].includes(l)) {
              return sum + getCount(it);
            }
            return sum;
          }, 0);
          merged.push({ ...item, label: "Kitap Bölümü", mergedLabels: ["Akademik Kitap Bölümü", "Popüler Kitap Bölümü"], value: siblingCount, count: siblingCount });
          hasBookSection = true;
        }
      } else {
        merged.push(item);
      }
    });
    return merged;
  };

  const renderCheckboxList = (items, category) => {
    if (!items) return null;
    let filteredItems = items;
    // Sadece documentTypes için kitap ve kitap bölümü birleştir
    if (category === "documentTypes") {
      filteredItems = mergeBookTypes(items);
    } else if (category === "databases") {
      filteredItems = mergeJournalDbs(items); // YENİ: Veritabanı birleştirme eklendi
    }
    // Show default short list, but for keywords when expanded show at most 10
    const displayCount = (() => {
      if (!Array.isArray(filteredItems)) return 0;
      if (showMore[category]) {
        if (category === "keywords") {
          return Math.min(filteredItems.length, 10);
        }
        return filteredItems.length;
      }
      return showCountDefault;
    })();
    const selectedItems = selectedFilters[category] || [];
    const isKeywordCategory = category === "keywords" || category === "journals" || category === "languages";

    let filteredExtra = extraFilters[category] || null;

    return (
      <>
        {/* Ana filtreler (seçili olanlar) */}
        {filteredItems.slice(0, displayCount).map((item, i) => {
          // Kitap/kitap bölümü için, arka planda iki değeri birden seçili say
          let checked = false;
          if (item.mergedLabels) {
            checked = item.mergedLabels.some(lbl => selectedItems.includes(lbl));
          } else {
            checked = isKeywordCategory
              ? selectedItems.some(f => f.searchkeyword === item.label)
              : selectedItems.includes(item.label);
          }
          return (
            <div className="form-check d-flex align-items-start" key={i}>
              <input
                className="form-check-input mt-0 me-1"
                type="checkbox"
                checked={checked}
                id={`${category}-${i}`}
                onChange={() => {
                  if (item.mergedLabels) {
                    // Seçiliyse kaldır, değilse ekle (arka planda iki değer)
                    const allSelected = item.mergedLabels.every(lbl => selectedItems.includes(lbl));
                    if (allSelected) {
                      item.mergedLabels.forEach(lbl => onCheckboxChange(category, { label: lbl, remove: true }));
                    } else {
                      item.mergedLabels.forEach(lbl => onCheckboxChange(category, { label: lbl }));
                    }
                  } else {
                    onCheckboxChange(category, item);
                  }
                }}
                style={{ width: 16, height: 16, borderRadius: 3, borderWidth: 1.5 }}
              />
              <label
                className="form-check-label mb-0 d-flex justify-content-between align-items-start"
                htmlFor={`${category}-${i}`}
                style={{ width: "95%" }}
              >
                <span className="text-break text-darkfume text-xs" style={{ flex: 1 }}>
                  {item.label}
                </span>
                {typeof item.value !== "undefined" && (
                  <span className="text-muted ms-2 text-xs">
                    {item.value.toLocaleString("tr-TR")}
                  </span>
                )}
              </label>
            </div>
          );
        })}

        {/* ...existing code... */}
        {/* + Başka filtre ekle butonu (sadece anahtar kelimeler hariç) */}
        {category !== "keywords" && selectedItems.length > 0 && (
          <span
            className="text-darkfume text-xs mt-1 mb-1 d-inline-block"
            style={{ cursor: "pointer" }}
            onClick={() => handleExpandCategoryClick(category)}
          >
            + Başka filtre ekle{" "}
            <FeatherIcon
              icon={expandedCategory === category ? "chevron-up" : "chevron-down"}
              size={14}
              className="ms-1"
            />
          </span>
        )}
        {/* Eğer o kategori genişletildiyse, yeni gelen ek seçenekleri göster */}
        {expandedCategory === category && (
          <>
            {filteredExtra === null ? (
              // Loading durumu
              <div className="mt-2 d-flex align-items-center">
                <div className="spinner-border spinner-border-sm text-primary me-2" role="status">
                  <span className="visually-hidden">Yükleniyor...</span>
                </div>
                <span className="text-muted text-xs">Yükleniyor...</span>
              </div>
            ) : filteredExtra.length > 0 ? (
              // Ek seçenekler var
              <div className="mt-2">
                {(() => {
                  // For documentTypes, also merge book types in extra list
                  let itemsToRender = filteredExtra;
                  if (category === "documentTypes") {
                    itemsToRender = mergeBookTypes(filteredExtra);
                  } else if (category === "databases") {
                    itemsToRender = mergeJournalDbs(filteredExtra); // Veritabanı birleştirme buraya da eklendi
                  }
                  return itemsToRender.map((item, i) => (
                    <div className="form-check d-flex align-items-center" key={`extra-${i}`}>
                      <input
                        className="form-check-input mt-0 me-2"
                        type="checkbox"
                        checked={
                          item.mergedLabels
                            ? item.mergedLabels.some(lbl => selectedItems.includes(lbl))
                            : (isKeywordCategory
                              ? selectedItems.some(f => f.searchkeyword === item.label)
                              : selectedItems.includes(item.label))
                        }
                        id={`${category}-extra-${i}`}
                        onChange={() => {
                          if (item.mergedLabels) {
                            const allSelected = item.mergedLabels.every(lbl => selectedItems.includes(lbl));
                            if (allSelected) {
                              item.mergedLabels.forEach(lbl => onCheckboxChange(category, { label: lbl, remove: true }));
                            } else {
                              item.mergedLabels.forEach(lbl => onCheckboxChange(category, { label: lbl }));
                            }
                          } else {
                            onCheckboxChange(category, item);
                          }
                          onExpandCategory(null);
                        }}
                        style={{ width: 16, height: 16 }}
                      />
                      <label
                        className="form-check-label mb-0 d-flex align-items-center"
                        htmlFor={`${category}-extra-${i}`}
                        style={{ width: "95%" }}
                      >
                        <span className="text-xs text-darkfume" style={{ flex: 1 }}>
                          {item.label}
                        </span>
                        {(typeof item.count !== "undefined" || typeof item.value !== "undefined") && (
    <span className="text-muted ms-2 text-xs">
      {(item.count ?? item.value).toLocaleString("tr-TR")}
    </span>
  )}
                      </label>
                    </div>
                  ));
                })()}
              </div>
            ) : (
              // Ek seçenek yok
              <div className="mt-2">
                <span className="text-muted text-xs">
                  Eklenebilecek filtre yok
                </span>
              </div>
            )}
          </>
        )}

        {filteredItems.length > showCountDefault && (
          <div className="d-flex justify-content-between align-items-center mt-1">
            <button
              type="button"
              className="border-0 bg-transparent p-0 text-xs text-fume"
              onClick={() => setShowMore(prev => ({ ...prev, [category]: !prev[category] }))}
            >
              {showMore[category] ? "Daha az göster ▲" : "Daha fazla göster ▼"}
            </button>
            <span
              className="text-darkfume text-xs me-2"
              role="button"
              onClick={() => openModalForCategory(
                category,
                (category === "journals" && "Dergi Adı — Tümü") ||
                (category === "publishers" && "Yayıncılar — Tümü") ||
                (category === "languages" && "Dil — Tümü") ||
                (category === "databases" && "Veri Tabanları — Tümü") ||
                (category === "documentTypes" && "Yayın Türü — Tümü") ||
                (category === "keywords" && "Anahtar Kelimeler — Tümü") ||
                `${category} — Tümü`
              )}
            >
              Tümü
            </span>
          </div>
        )}

      </>
    );
  };


  const handleExpandCategoryClick = (category) => {
    if (expandedCategory === category) {
      onExpandCategory(null); // close if already open
    } else {
      onExpandCategory(category); // open if closed
    }
  };

  // LOADING SPINNER
  if (loadingFilters) {
    return (
      <aside className="position-relative" style={{ minHeight: 400 }}>
        <div className="mb-3 opacity-50 text-muted">
          <h5 className="fs-5 mb-3 d-flex align-items-center justify-content-center">
            {/* <FeatherIcon icon="filter" className="me-2" size={18} /> */}
            Filtreler
          </h5>
          <hr />
        </div>
        <div
          style={{
            position: "absolute",
            top: 200, // biraz daha aşağı
            left: 0,
            width: "100%",
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "center",
            zIndex: 10,
            flexDirection: "row"
          }}
        >
          <div className="spinner-border text-primary" style={{ width: 36, height: 36, marginTop: 8 }} role="status" />
        </div>
        {/* Tüm metinler muted olsun */}
        <div className="opacity-50 text-muted" style={{ pointerEvents: 'none', userSelect: 'none' }}>

          {/* Sadece Abone Olunan İçerikler - sadece kullanıcının abone olduğu veritabanı varsa göster */}
          {Array.isArray(userDatabase) && userDatabase.length > 0 && (
            <>
              <section className="mb-3">
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="onlySubscribed"
                    checked={selectedFilters.onlySubscribed || false}
                    onChange={(e) => onCheckboxChange("onlySubscribed", e.target.checked)}
                    style={{ width: 16, height: 16 }}
                  />
                  <label className="form-check-label text-darkfume text-xs" htmlFor="onlySubscribed">
                    Sadece Abone Olunan İçerikler
                  </label>
                </div>
              </section>
              <hr className="my-3" />
            </>
          )}

          {/* Yayın Türü */}
          <section className="mb-3">
            <div className="fs-6 mb-2 text-darkfume">Yayın Türü</div>
            {renderCheckboxList(filters.publicationTypes || [], "documentTypes")}
          </section>
          <hr className="my-3" />

          {/* Veri Tabanları */}
          <section className="mb-3">
            <div className="fs-6 mb-2 text-darkfume">Veri Tabanları</div>
            {renderCheckboxList(filters.databases || [], "databases")}
          </section>
          <hr className="my-3" />

          {/* Dil */}
          <section className="mb-3">
            <div className="fs-6 mb-2 text-darkfume">Dil</div>
            {renderCheckboxList(
              convertLanguages(filters.languages || []),
              "languages"
            )}
          </section>
          <hr className="my-3" />

          {/* Anahtar Kelimeler */}
          <section className="mb-3">
            <div className="fs-6 mb-2 text-darkfume">Anahtar Kelimeler</div>
            {renderCheckboxList(filters.keywords || [], "keywords")}
          </section>
          <hr className="my-3" />

          {/* Dergi Adı */}
          <section className="mb-3">
            <div className="fs-6 mb-2 text-darkfume">Dergi Adı</div>
            {renderCheckboxList(filters.journals || [], "journals")}
          </section>
          <hr className="my-3" />

          {/* Yayıncılar */}
          <section className="mb-3">
            <div className="fs-6 mb-2 text-darkfume">Yayıncılar</div>
            {renderCheckboxList(filters.publishers || [], "publishers")}
          </section>
          <hr className="my-3" />

          {/* Erişim Türü */}
          {/* <section className="mb-3">
            <div className="fs-6 mb-2 text-darkfume">Erişim Türü</div>
            {renderRadioList(filters.permission || [], "permission")}
          </section>
          <hr className="my-3" /> */}

          {/* Yıl */}
          <section className="mb-3">
            <div className="fs-6 mb-2 text-darkfume">Yıl</div>
            <div className="row g-2 align-items-center mb-1">
              <div className="col-4 me-0 pe-1">
                <input
                  type="number"
                  className="form-control-sm rounded-3 border shadow-none bg-white small text-xs"
                  placeholder="Min"
                  value={yearInputs?.startyear || ""}
                  min={1965}
                  max={2099}
                  onChange={e => onYearChange("startyear", e.target.value)}
                />
              </div>
              <div className="col-4 pe-1">
                <input
                  type="number"
                  className="form-control-sm rounded-3 border shadow-none bg-white small text-xs"
                  placeholder="Max"
                  value={yearInputs?.endyear || ""}
                  min={1965}
                  max={2099}
                  onChange={e => onYearChange("endyear", e.target.value)}
                />
              </div>
              <div className="col-4 d-flex justify-content-end">
                <button
                  className="btn btn-outline-newdarkfumetogreen btn-border-primary btn-sm text-xs"
                  type="button"
                  onClick={onYearApply}
                >
                  Uygula
                </button>
              </div>
            </div>
          </section>
          <hr className="my-3" />
          <button
            className="btn btn-outline-newdarkfumetogreen btn-border-primary text-xs btn-sm w-100 d-flex align-items-center justify-content-center"
            style={{ fontSize: 15 }}
            onClick={onClearFilters}
          >
            <FeatherIcon icon="x-circle" className="me-2" size={16} />
            Filtreleri Temizle
          </button>
        </div >
      </aside >
    );
  }

  return (
    <aside className="text-sm rounded-3">
      <div className="mb-3">
        <h5 className="text-fume mb-3 d-flex align-items-center justify-content-center" style={{ fontSize: "1.15rem" }}>
          Filtreler
        </h5>
        <hr />
      </div>

      {/* Sadece Abone Olunan İçerikler - sadece kullanıcının abone olduğu veritabanı varsa göster */}
      {Array.isArray(userDatabase) && userDatabase.length > 0 && (
        <>
          <section className="mb-3">
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                id="onlySubscribed"
                checked={selectedFilters.onlySubscribed || false}
                onChange={(e) => onCheckboxChange("onlySubscribed", e.target.checked)}
                style={{ width: 16, height: 16 }}
              />
              <label className="form-check-label text-darkfume text-xs" htmlFor="onlySubscribed">
                Sadece Abone Olunan İçerikler
              </label>
            </div>
          </section>
          <hr className="my-3" />
        </>
      )}

      {Array.isArray(filters.publicationTypes) && filters.publicationTypes.length > 0 && (
        <>
          <section className="mb-3">
            <div className="fs-6 mb-2 text-darkfume">Yayın Türü</div>
            {renderCheckboxList(filters.publicationTypes, "documentTypes")}
          </section>
          <hr className="my-3" />
        </>
      )}

      {Array.isArray(filters.databases) && filters.databases.length > 0 && (
        <>
          <section className="mb-3">
            <div className="fs-6 mb-2 text-darkfume">Veri Tabanları</div>
            {renderCheckboxList(filters.databases, "databases")}
          </section>
          <hr className="my-3" />
        </>
      )}

      {Array.isArray(filters.languages) && filters.languages.length > 0 && (
        <>
          <section className="mb-3">
            <div className="fs-6 mb-2 text-darkfume">Dil</div>
            {renderCheckboxList(convertLanguages(filters.languages), "languages")}
          </section>
          <hr className="my-3" />
        </>
      )}

      {Array.isArray(filters.keywords) && filters.keywords.length > 0 && (
        <>
          <section className="mb-3">
            <div className="fs-6 mb-2 text-darkfume">Anahtar Kelimeler</div>
            {renderCheckboxList(filters.keywords, "keywords")}
          </section>
          <hr className="my-3" />
        </>
      )}

      {Array.isArray(filters.journals) && filters.journals.length > 0 && (
        <>
          <section className="mb-3">
            <div className="fs-6 mb-2 text-darkfume">Dergi Adı</div>
            {renderCheckboxList(filters.journals, "journals")}
          </section>
          <hr className="my-3" />
        </>
      )}

      {Array.isArray(filters.publishers) && filters.publishers.length > 0 && (
        <>
          <section className="mb-3">
            <div className="fs-6 mb-2 text-darkfume">Yayıncılar</div>
            {renderCheckboxList(filters.publishers, "publishers")}
          </section>
          <hr className="my-3" />
        </>
      )}

      {/* Yıl filtresi her zaman görünür */}
      <section className="mb-3">
        <div className="fs-6 mb-2 text-darkfume">Yıl</div>
        <div className="row g-2 align-items-center mb-1">
          <div className="col-4 me-0 pe-1">
            <input
              type="number"
              className="form-control-sm rounded-3 border shadow-none bg-white small text-xs"
              placeholder="Min"
              value={yearInputs?.startyear || ""}
              min={1965}
              max={2099}
              onChange={e => onYearChange("startyear", e.target.value)}
            />
          </div>
          <div className="col-4 pe-1">
            <input
              type="number"
              className="form-control-sm rounded-3 border shadow-none bg-white small text-xs"
              placeholder="Max"
              value={yearInputs?.endyear || ""}
              min={1965}
              max={2099}
              onChange={e => onYearChange("endyear", e.target.value)}
            />
          </div>
          <div className="col-4 d-flex justify-content-end">
            <button
              className="btn btn-outline-newdarkfumetogreen btn-border-primary btn-sm text-xs"
              type="button"
              onClick={onYearApply}
            >
              Uygula
            </button>
          </div>
        </div>
      </section>

      <hr className="my-3" />
      <button
        className="btn btn-outline-newdarkfumetogreen btn-border-primary text-sm w-100 d-flex align-items-center justify-content-center"
        style={{ fontSize: 15 }}
        onClick={onClearFilters}
      >
        <FeatherIcon icon="x-circle" className="me-2" size={16} />
        Filtreleri Temizle
      </button>
      <ListFilterModal
        show={modalOpen}
        title={modalMeta.title}
        category={modalMeta.category}
        initialSelected={modalMeta.initialSelected}
        isKeywordCategory={modalMeta.isKeywordCategory}
        fetchItems={(cat) => fetchAggrItems(cat)}
        onApply={(cat, finalSelected) => {
          console.log('panel apply', cat, finalSelected);
          onApplyModalSelections?.(cat, finalSelected);
          onExpandCategory?.(null);
          setModalOpen(false);
        }}
        onClose={() => setModalOpen(false)}
      />

    </aside>
  );
};

export default FilterPanel;
